import React from 'react'
import I18n from 'APP/I18n'
import Icon from 'APP/Converse/Icon'
import Typography from 'APP/Converse/Typography'
import { BannerContainer, TextContent } from './style'
import { useTheme } from 'styled-components/native'

const VirtualCareAccountBanner = () => {
  const theme = useTheme()
  return (
    <BannerContainer testID="VIRTUAL_CARE_ACCOUNT_BANNER">
      <Icon
        src="info-outline"
        size={theme.metrics.icon.small}
        variant="materialIcons"
        color="text"
      />
      <TextContent>
        <Typography variant="subheaderBold">{I18n.t('VirtualCareAccountBanner.title')}</Typography>
        <Typography variant="bodySmall">
          {I18n.t('VirtualCareAccountBanner.description')}
        </Typography>
      </TextContent>
    </BannerContainer>
  )
}

export default VirtualCareAccountBanner
